import { Container } from "@mui/material";
import Physics from '../Assets/Physics.png';
import Chemistry from '../Assets/Chemistry.png';
import Biology from '../Assets/Biology.png';
import Library from '../Assets/Library.png';
import Activity from '../Assets/Activity.png';
import Sports from '../Assets/Sports.png';

const facilitiesData = [
  {
    section: "Science & Academic Laboratories",
    description:
      "Well-equipped laboratories designed to encourage hands-on learning, experimentation, and conceptual clarity.",
    items: [
      { name: "Physics Laboratory", size: "9.14m × 6.23m", image: Physics },
      { name: "Chemistry Laboratory", size: "9.75m × 8m", image: Chemistry },
      { name: "Biology Laboratory", size: "9.14m × 6.23m", image: Biology },
    ],
  },
  {
    section: "Technology & Knowledge Spaces",
    description:
      "Dedicated spaces that promote digital literacy, research skills, and a strong reading culture.",
    items: [
      { name: "Library", size: "17.6m × 8m", image: Library },
    ],
  },
  {
    section: "Creative & Activity Areas",
    description:
      "Spaces that support creativity, collaboration, physical activity, and holistic development.",
    items: [
      { name: "Activity Room", size: "8.15m × 6.23m", image: Activity },
      { name: "Sports Room", size: "Dedicated Indoor Sports Area", image: Sports },
    ],
  },
];

export default function Facilities() {
  return (
    <div className="bg-[#F5F7FA]">

      {/* HEADER */}
      <div className="bg-gradient-to-r from-red-600 to-[#ff4e1c] py-20 text-center text-white">
        <h1 className="text-4xl md:text-5xl font-extrabold">Our Facilities</h1>
        <p className="mt-3 text-white/90 max-w-2xl mx-auto">
          World-class infrastructure designed to support academic excellence,
          innovation, and all-round development.
        </p>
      </div>

      {/* CONTENT */}
      <Container maxWidth="lg" className="py-24 space-y-28">

        {facilitiesData.map((section, idx) => (
          <section key={idx}>
            <div className="max-w-3xl mb-14">
              <h2 className="text-3xl font-bold text-[#0A1F44] mb-3">
                {section.section}
              </h2>
              <p className="text-gray-600 text-lg">
                {section.description}
              </p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {section.items.map((item, i) => (
                <div key={i} className="group bg-white rounded-3xl overflow-hidden shadow-md hover:shadow-xl transition-all">
                  <div className="relative h-52 overflow-hidden">
                    <img src={item.image} alt={item.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-black/10" />
                  </div>

                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      {item.name}
                    </h3>
                    <p className="text-gray-600 text-sm">
                      {item.size}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))}

      </Container>
    </div>
  );
}
